import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from "./actionTypes";

// FORGET PASSWORD
export const userForgetPassword = (user, history) => ({
  type: FORGET_PASSWORD,
  payload: { user, history },
});

export const userForgetPasswordSuccess = (message) => ({
  type: FORGET_PASSWORD_SUCCESS,
  payload: message,
});

export const userForgetPasswordError = (message) => ({
  type: FORGET_PASSWORD_ERROR,
  payload: message,
});

// RESET PASSWORD
export const userResetPassword = (data, history) => ({
  type: RESET_PASSWORD,
  payload: { data, history },
});

export const userResetPasswordSuccess = (message) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: message,
});

export const userResetPasswordError = (message) => ({
  type: RESET_PASSWORD_ERROR,
  payload: message,
});